import { Container, Col, Row, Label } from "reactstrap";
import { DeviceQuestionnaireChoiceDto, QuestionDto } from "../../../services/dto";
import Form from "../../../assets/vfx/form/form";
import { PencilFill } from "react-bootstrap-icons";
import { QuestionTypes } from "../question/questionForm";
import DisplayData from "../../common/DisplayData/DisplayData";
import VoteBar from "../../common/VoteBar";


interface PollQuestionProps {
  question: QuestionDto | undefined;
  onEdit?: () => void;
}

interface QuestionnairePollResponseProps {
    questionnaireResponse: DeviceQuestionnaireChoiceDto[] | undefined;
    onEdit?: () => void;
}

export const QuestionnairePollQuestion = (props: PollQuestionProps) => {
  return (
      <>
          <Container className="p-0">
              <Row>
                  <Col md={8}>
                      <DisplayData text="Question" importedData={props?.question?.name} />
                      {props.onEdit &&
                          <Form.Button
                              className="btn btn-none"
                              type="button"
                              onClick={props.onEdit}
                          >
                              <PencilFill />
                          </Form.Button>
                      }
                  </Col>
              </Row>
              <div className="d-flex flex-column p-3">
                  {
                      [QuestionTypes.Checkbox.toLowerCase(), QuestionTypes.Dropdown.toLowerCase(), QuestionTypes.Radio.toLowerCase()].includes(props?.question?.questionTypeId ?? "") &&
                      <div className="d-flex flex-column ms-3">
                          {props?.question?.options?.map((option) => (
                              <div key={option?.id}>
                                  {option.name}
                              </div>
                          ))}
                      </div>
                  }
              </div>
          </Container>
    </>
  );
};


export const QuestionnairePollQuestionResponse = (props: QuestionnairePollResponseProps) => {

    return (
        <>
            <Container className="p-0">
                {
                    props.questionnaireResponse && props.questionnaireResponse.map((response) => (
                        <>
                            <Row>
                                <Col md={8}>
                                    <DisplayData text="Question" importedData={response.question} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <span>{response.choices?.reduce((sum, item) => item.responseCount ? sum + item.responseCount : sum + 0, 0) ?? 0} { " votes"}</span> 
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                <div className="d-flex flex-column p-3">
                                    {
                                        response.choices &&
                                        <div className="d-flex flex-column ms-3">
                                                {response.choices?.map((option) => (
                                                    <VoteBar option={option.option} variant={"dark"} votes={option.responseCount ?? 0} totalCount={response.choices?.reduce((sum, item) => item.responseCount ? sum + item.responseCount : sum + 0, 0) ?? 0} />
                                            ))}
                                        </div>
                                    }
                                    </div>
                                </Col>
                            </Row>
                        </>
                    ))
                }
            </Container>
        </>
    );
};